export default function() {
  return {
    posts: []
  }
}
